import React from 'react';

const ValidatedInput = ({
  label,
  name,
  value,
  onChange,
  isRequired = false,
  isInvalid = false,
  message = 'Invalid input',
  type = 'text'
}) => {
  return (
    <div className="validated-input form-group">
      <div className="input-label">
        <label className={`${isRequired && 'required-field'}`}>{label}</label>
        <span className={`${isInvalid ? 'invalid-field' : 'hidden'}`}>{message}</span>
      </div>

      <input
        type={type}
        className={`form-control ${isInvalid && 'invalid-input'}`}
        defaultValue={value}
        name={name}
        onChange={onChange}
      />
    </div>
  );
};

export default ValidatedInput;



// WEBPACK FOOTER //
// ./src/features/shared-components/UI-components/ValidatedInput.js